import ManagementDashboardFeature from "./ManagementDashboardFeature";

export default ManagementDashboardFeature;
